import BriefcaseIcon from 'mdi-react/BriefcaseIcon'
import OfficeBuildingIcon from 'mdi-react/OfficeBuildingIcon'
import WrenchIcon from 'mdi-react/WrenchIcon'
import React from 'react'
import { useCompanyInfo } from 'scenes/Dashboard/data/deals/hooks'
import { Organization } from 'scenes/Dashboard/data/organizations/types'
import { makeStyles } from 'tss-react/mui'

import { Theme, Typography } from '@mui/material'

export type OrganizationPropertiesProps = {
  className?: string
  style?: React.CSSProperties
  organization: Organization
}

export const OrganizationProperties = React.memo(({ organization }: OrganizationPropertiesProps) => {
  const { classes } = useStyles()
  const { organizationSectors, organizationEnablers, organizationHeadquarters } = useCompanyInfo(organization)

  return (
    <>
      {organizationSectors && (
        <div className={classes.alignedRow}>
          <BriefcaseIcon className={classes.iconLabel} />
          <Typography variant="body2">{organizationSectors}</Typography>
        </div>
      )}
      {organizationEnablers && (
        <div className={classes.alignedRow}>
          <WrenchIcon className={classes.iconLabel} />
          <Typography variant="body2">{organizationEnablers}</Typography>
        </div>
      )}
      {organizationHeadquarters && (
        <div className={classes.alignedRow}>
          <OfficeBuildingIcon className={classes.iconLabel} />
          <Typography variant="body2">{organizationHeadquarters}</Typography>
        </div>
      )}
    </>
  )
})

OrganizationProperties.displayName = 'OrganizationProperties'

const useStyles = makeStyles()(({ spacing, palette }: Theme) => ({
  mainDataContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: spacing(0.5),
    marginBottom: spacing(0.5),
  },
  iconLabel: {
    width: spacing(2),
    height: spacing(2),
    fill: palette.primary.main,
    marginTop: spacing(0.25),
    marginRight: spacing(),
    flexShrink: 0,
  },
  alignedRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: spacing(0.5),
  },
  investorDetailsLink: {
    display: 'inline-flex',
    alignItems: 'center',
    marginLeft: spacing(),
    verticalAlign: 'middle',
  },
  investorDetailsLinkIcon: {
    width: spacing(2),
    height: spacing(2),
    color: palette.grey[600],
  },
}))
